//jacques-andre-editeur\proshop-v2\frontend\src\slices\booksCollectionsApiSlice.js
import { BOOKSCOLLECTIONS_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const booksCollectionsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBooksCollections: builder.query({
      query: ({ keyword, pageNumber, isAdminSpace, sortKey, sortDirection, parPage } = {}) => ({
      //query: ({ keyword, pageNumber, isAdminSpace, sortKey, sortDirection, parPage }) => ({
        url: BOOKSCOLLECTIONS_URL,
        method: 'GET',
        params: { keyword, pageNumber, isAdminSpace, sortKey, sortDirection, parPage },
      }),
      keepUnusedDataFor: 5,
      providesTags: ['BooksCollections'],
    }),

    getBooksCollectionDetailsById: builder.query({
      query: ({ booksCollectionId, isAdminSpace }) => ({
        url: `${BOOKSCOLLECTIONS_URL}/${booksCollectionId}`,
        params: { isAdminSpace },
      }),
      keepUnusedDataFor: 5,
      providesTags: (result, error, { booksCollectionId }) => [{ type: 'BookCollection', id: booksCollectionId }],
    }),
        
    getBooksCollectionDetails: builder.query({
      query: ({ slug, isAdminSpace }) => ({
        url: `${BOOKSCOLLECTIONS_URL}/slug/${slug}`, // Modification pour appeler l'API avec le slug
        params: { isAdminSpace },
      }),
      keepUnusedDataFor: 5,
      providesTags: (result, error, { booksCollectionId }) => [{ type: 'BookCollection', id: booksCollectionId }],
    }),

    createBooksCollection: builder.mutation({
      query: (data) => ({
        url: BOOKSCOLLECTIONS_URL,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['BooksCollections'],
    }),
    
    updateBooksCollection: builder.mutation({
      query: ({ booksCollectionId, ...data }) => ({
        url: `${BOOKSCOLLECTIONS_URL}/${booksCollectionId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['BooksCollections'],
    }),
    deleteBooksCollection: builder.mutation({
      query: (id) => ({
        url: `${BOOKSCOLLECTIONS_URL}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['BooksCollections'],
    }),
    
    toggleBooksCollectionVisibility: builder.mutation({
      query: (booksCollectionId) => ({
        url: `${BOOKSCOLLECTIONS_URL}/${booksCollectionId}/visibility`,
        method: 'PUT',
      }),
      invalidatesTags: ['BooksCollection'],
    }),

    toggleBooksCollectionInList: builder.mutation({
      query: (booksCollectionId) => ({
        url: `${BOOKSCOLLECTIONS_URL}/${booksCollectionId}/inList`,
        method: 'PUT',
      }),
      invalidatesTags: ['BooksCollection'],
    }),

  }),
});  

export const {
  useGetBooksCollectionsQuery,
  useGetBooksCollectionDetailsQuery,
  useGetBooksCollectionDetailsByIdQuery,
  useCreateBooksCollectionMutation,
  useUpdateBooksCollectionMutation,
  useDeleteBooksCollectionMutation,
  useToggleBooksCollectionVisibilityMutation,
  useToggleBooksCollectionInListMutation,
} = booksCollectionsApiSlice;
